import React from 'react';
import { getEventMenuPropsFromEvent } from '../../../layout.utils';
import { CustomizableHeader } from '../CustomizableHeader/CustomizableHeader';
import EventMenu from '../EventMenu/EventMenu';
import { useWebsiteHeaderSettings } from '@apps/guest/websiteHeader';
import { EventPageFragment } from '@graphql/generated';
import { useEventInfo } from '@shared/utils/eventInfo';
import { GuestSiteEvent } from '../../../layout.types';
import { LegacyHeader } from '../LegacyHeader/LegacyHeader';
import { useColorPaletteProvider } from '../../../ColorPaletteProvider/ColorPaletteProvider';

type TelemetryEditPhotoActions = {
  onChangePhotoButtonClicked: () => void;
  onEditPhotoOpenedChange: (opened: boolean) => void;
  onFocusPointChange: (prevPoint: unknown, newPoint: unknown) => void;
  onFocusPointChangeError: (error: unknown) => void;
};

type WebsiteHeaderProps = {
  eventDisplayName?: string | null;
  greeting?: string | null;
  artBackgroundFontColor?: string;
  telemetryEditPhotoActions: TelemetryEditPhotoActions;
  handleMenuOpenedChange: (isOpen: boolean) => void;
  handleMenuClicked: (pageClicked: string) => void;
  event: GuestSiteEvent;
  pages: EventPageFragment[];
};

export const WebsiteHeader = ({
  eventDisplayName,
  greeting,
  artBackgroundFontColor,
  telemetryEditPhotoActions,
  handleMenuOpenedChange,
  handleMenuClicked,
  event,
  pages,
}: WebsiteHeaderProps) => {
  const { eventHandle } = useEventInfo();
  const { websiteHeader } = useWebsiteHeaderSettings({
    eventHandle: eventHandle || '',
    targetWebsiteLayout: 'aloha',
  });
  const { pageColor } = useColorPaletteProvider();

  if (websiteHeader) {
    return (
      <CustomizableHeader
        eventHandle={eventHandle || ''}
        telemetryPhotoEditor={telemetryEditPhotoActions}
        websiteHeader={websiteHeader}
        fontColor={artBackgroundFontColor}
      >
        <EventMenu
          eventProps={getEventMenuPropsFromEvent(event)}
          handleMenuOpenedChange={handleMenuOpenedChange}
          handleMenuClicked={handleMenuClicked}
          title={eventDisplayName}
          eventHandle={eventHandle || ''}
          backgroundColor={pageColor}
        />
      </CustomizableHeader>
    );
  }

  return (
    <LegacyHeader
      eventHandle={eventHandle || ''}
      telemetryPhotoEditor={telemetryEditPhotoActions}
      title={eventDisplayName}
      subtitle={greeting}
    >
      <EventMenu
        eventProps={getEventMenuPropsFromEvent(event)}
        handleMenuOpenedChange={handleMenuOpenedChange}
        handleMenuClicked={handleMenuClicked}
        title={eventDisplayName}
        eventHandle={eventHandle || ''}
        backgroundColor={pageColor}
      />
    </LegacyHeader>
  );
};

WebsiteHeader.displayName = 'WebsiteHeader';
